import { render, staticRenderFns } from "./educationDetails.vue?vue&type=template&id=ae495620&"
import script from "./educationDetails.vue?vue&type=script&lang=js&"
export * from "./educationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports